import { type PlayerTrackData } from '../../tracking.ts';
import logger from '~/services/logger';
import { getJWPLTX } from './jwpltx';

async function jwAnalyticsPlugin(
  this: any,
  {
    trackData,
    playableItem,
    token,
    userId,
  }: {
    trackData: PlayerTrackData;
    playableItem: any;
    token: string;
    userId: string;
  }
) {
  this.on('loadedmetadata', async () => {
    if (this.liveTracker && this.liveTracker.isLive()) {
      this.isLiveMedia = true;
    }

    if (this.jwpltx) {
      logger.info(
        'postEvent: player presented and previous JW session was not terminated, sendingRemainingData'
      );

      this.jwpltx.remove();
      this.jwpltx = null;
    }

    this.jwpltx = await getJWPLTX();

    const feedId = playableItem?.extensions?.feedId || '';

    this.jwpltx.ready(
      token, // Analytics token
      trackData.bundle_id, // Domain name
      feedId, // ID of referring feed
      trackData.media_id, // ID of media playing
      trackData.name, // Title of media playing
      trackData.sdk_version, // OS Version
      trackData.version, // Version Name
      userId // App User ID
    );
  });

  this.on('seeking', (data: any) => {
    this.isSeeking = true;
  });

  this.on('seeked', (data: any) => {
    this.isSeeking = false;
  });

  this.on('timeupdate', () => {
    const duration = this.duration();
    const currentTime = this.currentTime();
    const isLive = this?.isLiveMedia;

    if (!this.jwpltx) {
      logger.info(
        'onTimeUpdate: is being called outside of the player lifecycle, skipping event'
      );
      return;
    }

    if (this.isSeeking) {
      // Ignore seek events on live videos
      if (isLive) return;

      this.jwpltx.seek(currentTime, duration);
      this.isSeeking = false;
      this.jwpltx.seeked();

      return;
    }

    if (currentTime > 0 || isLive) {
      this.jwpltx.time(currentTime, isLive ? -1 : duration);
    }
  });

  this.on('ended', () => {
    if (this.jwpltx !== null) {
      this.jwpltx.complete();
      this.jwpltx = null;
    }
  });
}

export default jwAnalyticsPlugin;
